import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

const LOGO_URL =
  'https://static.readdy.ai/image/9ce25d869b896a3f5b856271bcc15d01/04593552a0ea563d300a18e4891c8936.jpeg';

export default function Privaatsuspoliitika() {
  return (
    <div className="min-h-screen bg-white flex flex-col font-sans">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center h-12 w-auto">
            <img src={LOGO_URL} alt="IISRAL Recycling OÜ" className="h-12 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-eco-green transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Tagasi avalehele
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-8 py-16">
          {/* Page title */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-6 h-0.5 bg-eco-green" />
              <span className="text-eco-green text-xs font-bold uppercase tracking-widest">Juriidiline teave</span>
            </div>
            <h1 className="text-4xl font-extrabold text-gray-900 mb-4">Privaatsuspoliitika</h1>
            <p className="text-sm text-gray-400">Viimati uuendatud: 20. märts 2026</p>
          </div>

          <div className="space-y-10 text-gray-600 text-sm leading-relaxed">

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">1. Vastutav töötleja</h2>
              <p>
                Teie isikuandmete vastutav töötleja on <strong>IISRAL Recycling OÜ</strong>. Küsimuste
                korral võtke meiega ühendust:{' '}
                <a href="mailto:recycling@iisral.eu" className="text-eco-green hover:underline font-medium">
                  recycling@iisral.eu
                </a>{' '}
                või telefonil{' '}
                <a href="tel:+37253400444" className="text-eco-green hover:underline font-medium">
                  +372 5340 0444
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">2. Milliseid andmeid kogume</h2>
              <p className="mb-3">Kogume üksnes andmeid, mida te ise meile edastate, sh:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Nimi ja kontaktandmed (nt e-post, telefon), mille esitate kontaktvormi kaudu</li>
                <li>Sõnumid ja päringud, mille meile saadate</li>
                <li>Küpsiste kaudu kogutavad veebilehe kasutusandmed (vt Küpsiste poliitika)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">3. Andmete kasutamise eesmärk</h2>
              <p className="mb-3">Kasutame kogutud andmeid järgmistel eesmärkidel:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Teie päringutele vastamiseks ja teenuste pakkumiseks</li>
                <li>Veebilehe toimimise ja kasutajakogemuse parandamiseks</li>
                <li>Seadusjärgsete kohustuste täitmiseks</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">4. Õiguslik alus</h2>
              <p>
                Töötleme isikuandmeid GDPR artikkel 6 alusel: teie nõusolek (kontaktivorme täites),
                lepingueelsete meetmete rakendamine ning meie õigustatud huvid veebilehe parandamisel.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">5. Andmete säilitamine</h2>
              <p>
                Säilitame andmeid nii kaua, kui see on vajalik kogumise eesmärgi täitmiseks või
                seadusjärgsete kohustuste täitmiseks — üldjuhul kuni 3 aastat pärast viimast kontakti.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">6. Teie õigused</h2>
              <p className="mb-3">Teil on õigus:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Saada teavet enda andmete töötlemise kohta</li>
                <li>Nõuda andmete parandamist või kustutamist</li>
                <li>Esitada vastuväiteid andmete töötlemisele</li>
                <li>Esitada kaebus Andmekaitse Inspektsioonile (aki.ee)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">7. Andmete edastamine kolmandatele osapooltele</h2>
              <p>
                Me ei müü ega anna teie isikuandmeid edasi kolmandatele osapooltele ilma teie nõusolekuta,
                v.a seadusjärgsete kohustuste täitmiseks.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">8. Küpsised</h2>
              <p>
                Teavet küpsiste kasutamise kohta leiate meie{' '}
                <Link to="/kupsiste-poliitika" className="text-eco-green hover:underline font-medium">
                  Küpsiste poliitikast
                </Link>
                .
              </p>
            </section>

          </div>

          {/* Back link */}
          <div className="mt-14 pt-8 border-t border-gray-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-eco-green text-white text-sm font-bold px-6 py-3 rounded-full cursor-pointer whitespace-nowrap hover:bg-dark-green transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </div>
              Tagasi avalehele
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
